@if (loggedIn()) {
  <a
    [routerLink]="applyLink()"
    [queryParams]="applyQueryParams()"
    [target]="applyTarget()"
    class="ct-btn ct-btn-themed apply-btn"
  >
    <fa-icon [icon]="icons.pen" class="me-2"></fa-icon>
    {{ 'jobboard.views.job.apply-now-manually' | transloco }}
  </a>
  @if (!hasApplied()) {
    <button
      type="button"
      class="ct-btn ct-btn-themed-solid apply-btn"
      (click)="openApplyWithProfile()"
    >
      <fa-icon [icon]="icons.apply" class="me-2"></fa-icon>
      {{ 'jobboard.views.job.apply-now-with-profile' | transloco }}
    </button>
  }
} @else {
  <a
    [routerLink]="applyLink()"
    [queryParams]="applyQueryParams()"
    [target]="applyTarget()"
    class="ct-btn ct-btn-themed-solid apply-btn"
  >
    {{ 'jobboard.views.job.apply-now' | transloco }}
  </a>
}
